import ApiClient from 'devour-client'

import axios from 'axios'

const apiUrl = ''

const apiClient = new ApiClient({ apiUrl })
apiClient.use_cookies = true

apiClient.setToken = (token) => {
  apiClient.headers.Authorization = `Bearer ${token}`
}

apiClient.useCookies = (flag) => {
  apiClient.use_cookies = flag
}

apiClient.setSubdomain = (subdomain) => {
  apiClient.headers['X-TBK-AcademyHost'] = subdomain
}

apiClient.setUrl = (url) => {
  apiClient.apiUrl = url
}

apiClient.setGuestToken = (token) => {
  apiClient.headers['X-TBK-GuestToken'] = token
}

apiClient.setLocale = (locale) => {
  apiClient.headers['X-TBK-Locale'] = locale
}

function _csrfToken() {
  return document.querySelector('meta[name=csrf-token]').content
}

const railsCsrfMiddleware = {
  name: 'rails-csrf-middleware',
  req: (payload) => {
    if (payload.req.method !== 'GET') {
      payload.req.headers['X-CSRF-TOKEN'] = _csrfToken()
      payload.jsonApi.axios.defaults.withCredentials = payload.jsonApi.use_cookies
    }
    return payload
  }
}
// TODO: exclude or override for admin
const sessionTimeoutErrorMiddleware = {
  name: 'session-timeout-error-middleware',
  error: (payload) => {
    if (payload.response && payload.response.status === 401) {
      return (window.location.pathname = '/home/back')
    }
    return payload
  }
}
apiClient.axios = axios

apiClient.insertMiddlewareBefore('axios-request', railsCsrfMiddleware)
apiClient.insertMiddlewareBefore('errors', sessionTimeoutErrorMiddleware)

export { apiClient as default }
